import React, { Component } from 'react'
import { defaultTheme } from '@ow/theme'
import Description from './Description'
import Title from './Title'
import StyledToast from './styled'
import RenderIf from '../render-if'

class Toast extends Component {
  constructor() {
    super()
    this.transitionTime = 10000
    this.state = { notices: [] }
    this.removeNotice = this.removeNotice.bind(this)
  }

  // 设置key值
  getNoticeKey() {
    const { notices } = this.state
    return `notice-${new Date().getTime()}-${notices.length}`
  }

  // 添加提示
  // eslint-disable-next-line react/no-unused-class-component-methods
  addNotice(notice) {
    const { notices } = this.state
    notice.key = this.getNoticeKey()
    notices[0] = notice
    this.setState({ notices })
    if (notice.duration > 0) {
      setTimeout(() => {
        this.removeNotice(notice.key)
      }, notice.duration)
    }
    return () => {
      this.removeNotice(notice.key)
    }
  }

  // 移除提示
  removeNotice(key) {
    const { notices } = this.state
    this.setState({
      notices: notices.filter((notice) => {
        if (notice.key === key) {
          if (notice.onClose) setTimeout(notice.onClose, this.transitionTime)
          return false
        }
        return true
      }),
    })
  }

  render() {
    const { notices } = this.state
    return (
      <div style={{ zIndex: '999', position: 'fixed' }}>
        {/* position里面写提示框的定位格式如下 position="top center"注意：top与center之间必须是空格 */}
        {notices.map((notice) => {
          const {
            type = 'info',
            theme = defaultTheme,
            title,
            description,
            position,
          } = notice
          console.log(position + '----position')
          return (
            <StyledToast
              type={type}
              theme={theme}
              position={position}
              key={notice.key}
            >
              {/* <div> */}
              <div className="message-notice-content">
                <RenderIf isTrue={title}>
                  <Title text={title} type={type} theme={theme} />
                </RenderIf>
                <RenderIf isTrue={description}>
                  <Description text={description} type={type} theme={theme} />
                </RenderIf>
              </div>
            </StyledToast>
          )
        })}
      </div>
    )
  }
}

export default Toast
